import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

const reviews = [
  {
    name: "Kristina J.",
    quote:
      "Finally — I have my dream smile! After nearly four years with Kartik and the team, I felt connected and never alone. They truly love what they do.",
    when: "7 months ago",
  },
  {
    name: "Camilla B.",
    quote:
      "Kartik is a perfectionist. He ensured I was happy with the plan and was always a WhatsApp message away. Two years on and everything is still looking so good.",
    when: "4 years ago",
  },
  {
    name: "James M. Tully",
    quote:
      "Effortless once I got my scan. Highly recommend — I'm delighted with how my teeth turned out.",
    when: "10 months ago",
  },
  {
    name: "Hannah A.",
    quote:
      "Tailored appointments, ensuring you feel confident every step of the way. His passion for his work is evident — exceptional care from start to finish.",
    when: "1 year ago",
  },
];

export const Reviews = () => {
  return (
    <section data-testid="reviews-section" className="py-24 lg:py-32 bg-rb-bg">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-12">
          <div className="lg:col-span-7">
            <div className="font-overline mb-4">Loved by patients</div>
            <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-rb-text leading-[1.1]">
              5.0★ on Google.
              <br />
              <span className="italic text-[#93C5FD]">Real words from real patients.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end justify-start lg:justify-end">
            <a
              href="https://www.google.com/maps/place/Restore.Dental"
              target="_blank"
              rel="noreferrer"
              data-testid="reviews-google-link"
              className="text-sm text-rb-text-2 hover:text-rb-text underline decoration-[#93C5FD]/40 underline-offset-4"
            >
              Read all reviews on Google →
            </a>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {reviews.map((r, i) => (
            <motion.div
              key={r.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="card-soft p-7"
              data-testid={`review-card-${i}`}
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star
                    key={k}
                    size={14}
                    strokeWidth={1.5}
                    className="fill-[#93C5FD] text-[#93C5FD]"
                  />
                ))}
              </div>
              <p className="font-serif-display text-xl text-rb-text leading-snug mb-5 italic">
                "{r.quote}"
              </p>
              <div className="flex items-center justify-between text-xs text-rb-text-2">
                <span className="font-medium text-rb-text">{r.name}</span>
                <span>{r.when}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
